module.exports = __webpack_public_path__ + "static/media/shape-3.7a402554.svg";